import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  userInfo: {},
  login: false,
  isCollapse:false
}
const mutations = {
  changeUserInfo (state, v) {
    state.userInfo = v
  },
  $_setToken (state, value) {
    // 设置存储token
    state.token = value
    localStorage.setItem('token', value)
  },
  $_removeStorage (state, value) {
    // 删除token
    localStorage.removeItem('token')
  },
  updateCollapse (context, data) {
    context.isCollapse = data
  },
}
const getters = {
  // 监听数据变化
  getStorage (state) {
    // 获取本地存储的登录信息
    if (!state.token) {
      state.token = JSON.parse(localStorage.getItem())
    }
    return state.token
  }
}
export default new Vuex.Store({
  // 所有的数据都放在state中
  state,
  // 操作数据，唯一的通道是mutations
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store.js